module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "admin-page-group"
  }, [_c('h1', {
    staticClass: "admin-page"
  }, [_vm._v("Crear plato")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-link pull-right",
    attrs: {
      "to": "/platos"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v("Volver al listado de Platos")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-style line-top"
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [(!_vm.$v.datosPlato.categoria.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe seleccionar una categoría")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de plato")]), _vm._v(" "), _c('div', {
    staticClass: "inline-group margin-top-10"
  }, _vm._l((_vm.categorias), function(categoria) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.datosPlato.categoria),
        expression: "datosPlato.categoria"
      }],
      attrs: {
        "type": "radio",
        "name": "radio"
      },
      domProps: {
        "value": categoria._id,
        "checked": _vm._q(_vm.datosPlato.categoria, categoria._id)
      },
      on: {
        "__c": function($event) {
          _vm.datosPlato.categoria = categoria._id
        }
      }
    }), _vm._v(" "), _c('i'), _c('span', {
      staticClass: "size-16"
    }, [_vm._v(_vm._s(categoria.nombre))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre del Plato")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.nombre),
      expression: "datosPlato.nombre"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ej: Vacío al horno con papas bravas"
    },
    domProps: {
      "value": (_vm.datosPlato.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPlato.nombre = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosPlato.nombre.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e(), (!_vm.$v.datosPlato.nombre.minLength) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El campo debe tener por lo menos " + _vm._s(_vm.$v.datosPlato.nombre.$params.minLength.min && _vm.mostrarErrores) + " caracteres.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.descripcion),
      expression: "datosPlato.descripcion"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "Escribe una descripción breve  del plato mencionando los principales ingredientes que se han utilizado, y redacta de forma atractiva para que los comenzales se tienten!"
    },
    domProps: {
      "value": (_vm.datosPlato.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPlato.descripcion = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosPlato.descripcion.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), (!_vm.imagenCargada) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Carga de la imagen")]), _vm._v(" "), _c('uploader', {
    attrs: {
      "url": _vm.urlUpload
    },
    on: {
      "upload-correct": _vm.onUploadCorrect
    }
  })], 1) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cambiarImagen($event)
      }
    }
  }, [_vm._v("Cambiar imagen")])]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.datosPlato.urlImagen,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.datosPlato && _vm.datosPlato.receta) ? _c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": '#nutricional'
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": 'nutricional'
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ingrediente (en singular)")]), _vm._v(" "), _c('div', {
    staticClass: "input-typeahead"
  }, [_c('vue-bootstrap-typeahead', {
    ref: "ingredientSelector",
    attrs: {
      "data": _vm.ingredients,
      "serializer": function (s) { return s.create ? '* ' + s.name : s.name; },
      "placeholder": "Escribi el ingrediente en singular..."
    },
    on: {
      "hit": function($event) {
        _vm.selectedIngredient = $event
      }
    },
    model: {
      value: (_vm.ingredientName),
      callback: function($$v) {
        _vm.ingredientName = $$v
      },
      expression: "ingredientName"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidad de Medida")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipeIngredient.measureUnit),
      expression: "recipeIngredient.measureUnit"
    }],
    ref: "slMeasureUnits",
    staticClass: "form-control select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.recipeIngredient.measureUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.measureUnits), function(mu) {
    return _c('option', {
      key: mu._id,
      domProps: {
        "value": mu._id
      }
    }, [_vm._v(_vm._s(mu.name))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cantidad")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipeIngredient.amount),
      expression: "recipeIngredient.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Cantidad"
    },
    domProps: {
      "value": (_vm.recipeIngredient.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recipeIngredient.amount = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addIngredient()
      }
    }
  }, [(_vm.selectedIngrediendIdx > -1) ? _c('span', [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Cambiar")]) : _c('span', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Agregar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-hover table-stripped table-no-first-pad"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.datosPlato.receta.ingredientes), function(ing, idx) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ing.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ing.amount) + " " + _vm._s(_vm.measureUnitsById[ing.measureUnit].name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editIngredient(ing, idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-pencil"
    })]), _vm._v(" "), (_vm.selectedIngrediendIdx === -1) ? _c('a', {
      staticClass: "btn btn-xs btn-ghost text-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeIngredient(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-times"
    })]) : _vm._e()])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.datosPlato.receta.edamam && (_vm.recipeStatus === 'ANALYZED' || _vm.recipeStatus === 'SAVED')) ? _c('button', {
    staticClass: "btn btn-brand",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showNutritionalInfo()
      }
    }
  }, [_vm._v("Ver tabla")]) : _vm._e(), _vm._v(" "), (_vm.recipeStatus === 'ANALYZE') ? _c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.analyze()
      }
    }
  }, [_vm._v("Analizar")]) : _vm._e(), _vm._v(" "), (_vm.datosPlato._id && _vm.recipeStatus === 'ANALYZED') ? _c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveRecipe()
      }
    }
  }, [_vm._v("Guardar Receta")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "modalInfo",
    staticClass: "modal",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.datosPlato.receta && _vm.datosPlato.receta.edamam && _vm.datosPlato.receta.edamam.totals) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('section', {
    staticClass: "performance-facts",
    attrs: {
      "id": "performance-facts"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "performance-facts__table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "nob"
  }, [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalCal))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Grasas totales")]), _vm._v(" " + _vm._s(_vm.datosPlato.receta.edamam.totals.FAT))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyFAT))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "blank-cell"
  }), _vm._v(" "), _c('th', [_vm._v("Grasas Saturadas " + _vm._s(_vm.datosPlato.receta.edamam.totals.FASAT))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyFASAT))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "blank-cell"
  }), _vm._v(" "), _c('th', [_vm._v("Grasas Trans " + _vm._s(_vm.datosPlato.receta.edamam.totals.FATRN))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Colesterol")]), _vm._v(" " + _vm._s(_vm.datosPlato.receta.edamam.totals.CHOLE))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyCHOLE))])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Sodio")]), _vm._v(" " + _vm._s(_vm.datosPlato.receta.edamam.totals.NA))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyNA))])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Carbohidratos totales")]), _vm._v(" " + _vm._s(_vm.datosPlato.receta.edamam.totals.CHOCDF))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyCHOCDF))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "blank-cell"
  }), _vm._v(" "), _c('th', [_vm._v("Fibra " + _vm._s(_vm.datosPlato.receta.edamam.totals.FIBTG))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyFIBTG))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "blank-cell"
  }), _vm._v(" "), _c('th', [_vm._v("Azúcares " + _vm._s(_vm.datosPlato.receta.edamam.totals.SUGAR))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "blank-cell"
  }), _vm._v(" "), _c('th', [_vm._v("Azúcar agregada " + _vm._s(_vm.datosPlato.receta.edamam.totals.SUGARadded))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "thick-end"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Proteínas")]), _vm._v(" " + _vm._s(_vm.datosPlato.receta.edamam.totals.PROCNT))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyPROCNT))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "performance-facts__table--grid"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Vitamin D " + _vm._s(_vm.datosPlato.receta.edamam.totals.VITD))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyVITD))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Calcio " + _vm._s(_vm.datosPlato.receta.edamam.totals.CA))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyCA))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Hierro " + _vm._s(_vm.datosPlato.receta.edamam.totals.FE))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyFE))])])]), _vm._v(" "), _c('tr', {
    staticClass: "thin-end"
  }, [_c('th', [_vm._v("Potasio " + _vm._s(_vm.datosPlato.receta.edamam.totals.K))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.datosPlato.receta.edamam.totals.totalDailyK))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "small-info",
    attrs: {
      "id": "small-nutrition-info"
    }
  }, [_vm._v("* Porcentaje de valor diario calculado sobre la base de una dieta de 2000 calorías")])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Observaciones")]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.observaciones),
      expression: "datosPlato.observaciones"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "Algunos datos extras que sea necesario comunicarle a tus comenzales..."
    },
    domProps: {
      "value": (_vm.datosPlato.observaciones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPlato.observaciones = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "title-label"
  }, [_vm._v("CARACTERÍSTICAS")]), _vm._v(" "), _c('div', {
    staticClass: "inline-group margin-top-10"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.aptoCeliacos),
      expression: "datosPlato.aptoCeliacos"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPlato.aptoCeliacos) ? _vm._i(_vm.datosPlato.aptoCeliacos, null) > -1 : (_vm.datosPlato.aptoCeliacos)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPlato.aptoCeliacos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPlato.aptoCeliacos = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPlato.aptoCeliacos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPlato.aptoCeliacos = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Sin Gluten")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.picante),
      expression: "datosPlato.picante"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPlato.picante) ? _vm._i(_vm.datosPlato.picante, null) > -1 : (_vm.datosPlato.picante)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPlato.picante,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPlato.picante = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPlato.picante = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPlato.picante = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Picante")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.vegetariano),
      expression: "datosPlato.vegetariano"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPlato.vegetariano) ? _vm._i(_vm.datosPlato.vegetariano, null) > -1 : (_vm.datosPlato.vegetariano)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPlato.vegetariano,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPlato.vegetariano = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPlato.vegetariano = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPlato.vegetariano = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Vegetariano")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPlato.vegano),
      expression: "datosPlato.vegano"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPlato.vegano) ? _vm._i(_vm.datosPlato.vegano, null) > -1 : (_vm.datosPlato.vegano)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPlato.vegano,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPlato.vegano = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPlato.vegano = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPlato.vegano = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Vegano")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clear-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-action text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickGuardar
    }
  }, [_vm._v("GUARDAR")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_vm._v("Informacion nutricional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ingrediente (en singular)")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "performance-facts__header"
  }, [_c('h1', {
    staticClass: "performance-facts__title"
  }, [_vm._v("Información nutricional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "amps",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Cantidades por Porción")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "id": "lkcal-val-cal"
    }
  }, [_c('b', [_vm._v("Calorias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "thick-row"
  }, [_c('td', {
    staticClass: "small-info",
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("% del valor diario*")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-350cc380"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Platos/PlatoForm.vue
// module id = 1120
// module chunks = 5